import { useMemo, useState } from 'react';
import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { STextField } from './styled';
import {
  Autocomplete,
  Box as MuiBox,
  TextField as MuiTextField,
} from '@mui/material';
import { FormAutocomplete, FormControl } from 'components/ui';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import { useDebounce } from 'use-debounce';
import { useSearchCity } from '../hooks/useSearchCity';
import { useForm } from 'react-final-form';

export default function PlaceOfBirthINS() {
  const { t } = useTranslation();

  const form = useForm();

  const [search, setSearch] = useState('');
  const [searchDebounced] = useDebounce(search);

  const { data, loading, error } = useSearchCity(searchDebounced);

  return (
    <Accordion
      startAdornment={<CakeOutlinedIcon />}
      title={t('Place of birth') + ' *'}
    >
      <FormControl label={t('Search')}>
        <FormAutocomplete
          name="search"
          options={data}
          loading={loading}
          inputOnChange={(value) => setSearch(value)}
          placeholder={t('Search')}
          getOptionLabel={(value) =>
            value.nom +
            ', ' +
            value.codesPostaux[0] +
            ', ' +
            value.departement.nom
          }
          filterOptions={(options) => options}
          onChange={(e, value) => {
            form.change('birthPlace.city', value.nom);
            form.change('birthPlace.zipcode', value.code);
            form.change('birthPlace.state', value.departement.nom);
            form.change('birthPlace.country', 'France');
          }}
        />
      </FormControl>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('City') + ' *'}>
          <STextField
            disabled
            name="birthPlace.city"
            placeholder={t('City')}
            dataId="place-of-birth-input"
          />
        </FormControl>
        <FormControl label={t('COG Code') + ' *'}>
          <STextField
            disabled
            name="birthPlace.zipcode"
            placeholder={t('COG code')}
            dataId="place-of-birth-input"
          />
        </FormControl>
      </MuiBox>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('State') + ' *'}>
          <STextField
            disabled
            name="birthPlace.state"
            placeholder={t('State')}
            dataId="place-of-birth-input"
          />
        </FormControl>
        <FormControl label={t('Country') + ' *'}>
          <STextField
            disabled
            name="birthPlace.country"
            data-id="country-input"
            placeholder={t('Country')}
          />
        </FormControl>
      </MuiBox>
    </Accordion>
  );
}
